export default __webpack_public_path__ + "64b31e17b8da312ebe87d51b28633394.png";